module.exports = __webpack_public_path__ + "img/index6.bed852e2.png";